// Anything reached by a click is fetched when it is clicked, and it is fetched by the exact
// filename the page that is running was built with. Every production build renames all of them
// and takes the previous names away, so a tab left open across a deployment asks the asset host
// for a file it no longer has. The click gets nothing, and so does every click after it.
//
// Nothing inside the page can repair that: the new filenames exist only in the new index, and
// fetching that means a full load. So a full load is what happens — the same thing the user
// would have done by hand, done before they have to work out that they should.
//
// Vite dispatches vite:preloadError for every dynamic import that fails to fetch — the module
// itself as well as the stylesheets pulled in beside it — so this one listener covers every
// lazy chunk in the app, and a lazy chunk added later is covered without being wired up.
//
// Reloading is rationed rather than counted: a page that has just reloaded and still cannot
// reach its chunks is not a stale page, and reloading it again would only trap the tab in a
// loop. A deployment an hour into the same session is a new problem and gets its own reload.
const lastRecoveryReloadKey = 'last-chunk-recovery-reload';

const recoveryReloadInterval = 60 * 1000;

function handlePreloadError() {

  // Offline is the one failure a reload makes worse: the chunk is unreachable either way, and
  // reloading trades a screen that still works for the browser's error page.
  if (navigator.onLine === false) {
    return;
  }

  if (hasReloadedRecently() === true) {
    return;
  }

  window.sessionStorage.setItem(lastRecoveryReloadKey, String(Date.now()));

  window.location.reload();

}

function hasReloadedRecently() {

  const lastReloadedAt = window.sessionStorage.getItem(lastRecoveryReloadKey);

  if (lastReloadedAt === null) {
    return false;
  }

  return Date.now() - Number(lastReloadedAt) < recoveryReloadInterval;

}

// The event is left un-cancelled on purpose: the error still reaches whoever asked for the
// module, so a loading state that has to become a failure state can still become one when the
// reload above is declined.
window.addEventListener('vite:preloadError', handlePreloadError);
